import { render, staticRenderFns } from "./FlvSplittingGrowth.vue?vue&type=template&id=299f9914&lang=html&"
import script from "./FlvSplittingGrowth.vue?vue&type=script&lang=js&"
export * from "./FlvSplittingGrowth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports